import { render, staticRenderFns } from "./levelFourPages.vue?vue&type=template&id=be088cb2&scoped=true&"
import script from "./levelFourPages.vue?vue&type=script&lang=js&"
export * from "./levelFourPages.vue?vue&type=script&lang=js&"
import style0 from "./levelFourPages.vue?vue&type=style&index=0&id=be088cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be088cb2",
  null
  
)

export default component.exports